import {isFirefox} from "react-device-detect"

export function checkIsFirefox() {
    return isFirefox
}
